import { cn } from "@punchup/utils/cn";

export default function SubHeader3({
  children,
  className,
  responsive,
}: {
  children: React.ReactNode;
  className?: string;
  responsive?: boolean;
}) {
  const fontSize = responsive ? "text-base md:text-xl" : "text-xl";
  return (
    <h5 className={cn(fontSize, "uppercase font-medium", className)}>
      {children}
    </h5>
  );
}
